export type { IMongoDescriptor } from '../database/index.js';

export interface ICloudflareDescriptor {
  authToken: string;
};

export interface ILetterExpressDescriptor {
  email: string,
  apiToken: string,
}
